// extracted by mini-css-extract-plugin
module.exports = {"contentText":"style_contentText__2Qnj4"};